// Mock data for Laundry Website

export const businessInfo = {
  name: "Laundry 24hr Lavanderia",
  tagline: "Wash & Fold Pickup & Delivery",
  phone: "762-436-2067",
  email: "familylaundry5265@gmail.com",
  address: "5265 Jimmy Carter Blvd Suite 6230, Norcross, GA 30093",
  laundromat_hours: "Laundromat Open 24/7",
  washfold_hours: "Wash & Fold Pickup & Delivery: 9 AM–4 PM",
  washfold_note: "Same-day service available for qualifying orders picked up before 4:00 PM",
  googleReviewsUrl: "https://maps.app.goo.gl/9fdtKKm65ThqUqia6"
};

export const services = [
  {
    id: 1,
    name: "Wash & Fold",
    description: "Professional washing, drying, and folding service with free pickup and delivery",
    icon: "Package",
    price: "$1.50/lb",
    priceSubtext: "$15 minimum order",
    // Uber pricing hidden for now - uncomment when launching on Uber Marketplace
    // secondaryPrice: "Uber Marketplace: $2.25/lb ($35 min)",
    features: [
      "Wash • Dry • Fold",
      "Free Pickup & Delivery",
      "Same-Day Service Available*",
      "Eco-Friendly Detergents"
    ],
    active: true,
    image: "https://images.unsplash.com/photo-1604176354204-9268737828e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmb2xkZWQlMjBjbG90aGVzfGVufDB8fHx8MTc2NjYwMDQ2NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Commercial Cleaning",
    description: "Large-scale laundry solutions for businesses and commercial clients",
    icon: "Building",
    price: "Contact for Quote",
    features: [
      "Bulk Pricing Available",
      "Scheduled Pickups",
      "Quality Guaranteed"
    ],
    active: false,
    comingSoon: true
  },
  {
    id: 3,
    name: "Carpet Cleaning",
    description: "Professional carpet cleaning services for homes and offices",
    icon: "Home",
    price: "Contact for Quote",
    features: [
      "Deep Steam Cleaning",
      "Stain Removal",
      "Fast Drying"
    ],
    active: false,
    comingSoon: true
  },
  {
    id: 4,
    name: "House Cleaning",
    description: "Complete house cleaning services for a spotless home",
    icon: "Sparkles",
    price: "Contact for Quote",
    features: [
      "Deep Cleaning",
      "Regular Maintenance",
      "Flexible Scheduling"
    ],
    active: false,
    comingSoon: true
  }
];

export const serviceAreas = [
  {
    id: 1,
    city: "Lawrenceville",
    pickupTime: "9:00 AM - 4:00 PM",
    sameDay: "Same-day service available for qualifying orders picked up before 4:00 PM",
    nextDay: "Pickups after 4:00 PM will be delivered the following day"
  },
  {
    id: 2,
    city: "Lilburn",
    pickupTime: "9:00 AM - 4:00 PM",
    sameDay: "Same-day service available for qualifying orders picked up before 4:00 PM",
    nextDay: "Pickups after 4:00 PM will be delivered the following day"
  },
  {
    id: 3,
    city: "Norcross",
    pickupTime: "9:00 AM - 4:00 PM",
    sameDay: "Same-day service available for qualifying orders picked up before 4:00 PM",
    nextDay: "Pickups after 4:00 PM will be delivered the following day"
  },
  {
    id: 4,
    city: "Snellville",
    pickupTime: "9:00 AM - 4:00 PM",
    sameDay: "Same-day service available for qualifying orders picked up before 4:00 PM",
    nextDay: "Pickups after 4:00 PM will be delivered the following day"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Schedule Pickup",
    description: "Book online or call us to schedule a convenient pickup time",
    icon: "Calendar"
  },
  {
    step: 2,
    title: "We Pick Up",
    description: "Our team arrives at your location to collect your laundry",
    icon: "Truck"
  },
  {
    step: 3,
    title: "Professional Care",
    description: "We wash, dry, and fold your clothes with expert care",
    icon: "Sparkles"
  },
  {
    step: 4,
    title: "Fast Delivery",
    description: "Receive your fresh, clean laundry the same day or following day",
    icon: "PackageCheck"
  }
];

export const features = [
  {
    id: 1,
    title: "24/7 Service",
    description: "Open 365 days a year for your convenience",
    icon: "Clock"
  },
  {
    id: 2,
    title: "High Performance Machines",
    description: "Front load washers & dryers for large loads",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Free WiFi",
    description: "Stay connected while you wait",
    icon: "Wifi"
  },
  {
    id: 4,
    title: "Comfortable Waiting Area",
    description: "Flat screen TVs and comfortable seating",
    icon: "Armchair"
  }
];

// Note: Individual testimonials removed - using Google Reviews only
// See Testimonials.jsx which links to businessInfo.googleReviewsUrl

export const loyaltyProgram = {
  title: "Loyalty Rewards Program",
  subtitle: "Get Your 11th Service FREE!",
  description: "After 10 Wash & Fold services, your 11th one is completely free. It's our way of saying thank you for being a valued customer.",
  terms: "*Terms and conditions apply. Offer valid for Wash & Fold services only."
};

// Mock booking submissions
let bookings = [];

export const submitBooking = (bookingData) => {
  const newBooking = {
    id: Date.now(),
    ...bookingData,
    status: "pending",
    createdAt: new Date().toISOString()
  };
  bookings.push(newBooking);
  console.log("Booking submitted:", newBooking);
  return newBooking;
};

export const getBookings = () => bookings;
